import React from "react";
import { Box } from "../../../lab/components";
import { alpha } from "../../../lab/system";
export const ToastBadge = ({ icon: Icon, color }) => {
    return (React.createElement(Box, { sx: {
            background: (theme) => theme.palette.background.main,
            borderRadius: (theme) => theme.radius.full,
            border: 1,
            padding: 0.5,
            borderColor: (theme) => alpha(theme.palette[color].main, 0.08),
        } },
        React.createElement(Box, { sx: {
                background: (theme) => alpha(theme.palette[color].main, 0.06),
                borderRadius: (theme) => theme.radius.full,
                border: 1,
                borderColor: (theme) => alpha(theme.palette[color].main, 0.09),
            } },
            React.createElement(Icon, { color: color, size: "xs" }))));
};
//# sourceMappingURL=ToastBadge.js.map